import React from 'react';
import { useFormikContext } from 'formik';
import DatePicker from 'react-datepicker';
import WrapperFormikField from './WrapperFormikField';
import styles from './ErrorMessagesShared.module.css';
import { Form } from 'react-bootstrap';

export default function DateField({ onChange = () => {}, ...restOfProps }) {
  const { setFieldValue } = useFormikContext();

  const handleChange = (value) => {
    onChange(value);
    setFieldValue(restOfProps.name, value);
  };

  return (
    <WrapperFormikField {...restOfProps}>
      {({ currentValue, errorField }) => (
        <>
          <DatePicker
            {...restOfProps}
            onChange={handleChange}
            value={currentValue}
            selected={currentValue}
            autoComplete="off"
            onKeyDown={(e) => e.preventDefault()}
            customInput={
              <Form.Control
                {...restOfProps}
                onChange={handleChange}
                value={currentValue}
                isInvalid={errorField}
              />
            }
          />

          {errorField && (
            <div className={styles.feedbackErrorMessages}>
              <li>{errorField}</li>
            </div>
          )}
        </>
      )}
    </WrapperFormikField>
  );
}
